import {dispatch, useSelect, select} from '@wordpress/data';
import {useEffect} from '@wordpress/element';



/**
 * [shetradesBlockView description]
 * @param  {[type]} props [description]
 * @return {[type]}       [description]
 */
export function shetradesBlockView(props) {
	

	/**
	 * [_dispatchSearch description]
	 * @param  {[type]} value [description]
	 * @return {[type]}       [description]
	 */
	function _dispatchSearch(e) {    
		jQuery('#form_stories_field_search').val(e.target.value);

	} 
	
    useEffect(() => {   
        var field_search = jQuery('#form_stories_field_search').val();  
        jQuery('#form_stories_front_field_search').val(field_search);
    }, [])


	return (				
		<div className="form-field">
			<input type="text" id="form_stories_front_field_search" placeholder="Type to search.." onChange={(e) => _dispatchSearch(e)} />
		</div>	
	);
} 